/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessResponseViewModel } from './AccessResponseViewModel';
import {
    AccessResponseViewModelFromJSON,
    AccessResponseViewModelFromJSONTyped,
    AccessResponseViewModelToJSON,
} from './AccessResponseViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfAccessResponseViewModel
 */
export interface ResultOfAccessResponseViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfAccessResponseViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAccessResponseViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAccessResponseViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAccessResponseViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAccessResponseViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfAccessResponseViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfAccessResponseViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {AccessResponseViewModel}
     * @memberof ResultOfAccessResponseViewModel
     */
    data?: AccessResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAccessResponseViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfAccessResponseViewModel interface.
 */
export function instanceOfResultOfAccessResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfAccessResponseViewModelFromJSON(json: any): ResultOfAccessResponseViewModel {
    return ResultOfAccessResponseViewModelFromJSONTyped(json, false);
}

export function ResultOfAccessResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfAccessResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : AccessResponseViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfAccessResponseViewModelToJSON(value?: ResultOfAccessResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': AccessResponseViewModelToJSON(value.data),
        'Count': value.count,
    };
}

